export default (api) => ({
  fetch: (agencyId, params) => api.$get(`agencies/${agencyId}/agents`, { params }),
  fetchOne: (id) => api.$get(`agents/${id}`),
  lastVersion: () => api.$get("agents/lastVersion"),
  tags: (agencyId) => api.$get(`agencies/${agencyId}/tags`),
  fetchDeployments: (agentId, params) => api.$get(`agents/${agentId}/deployments`, { params }),

  patch: (id, body) => api.$patch(`agents/${id}`, body),
  remove: (id) => api.$delete(`agents/${id}`),
  uninstall: (id) => api.$put(`agents/${id}/uninstall`),
  update: (id) => api.$put(`agents/${id}/update`),

  moveSelected: (agencyId, body) => api.$put(`agencies/${agencyId}/agents/move`, body),
  deleteSelected: (agencyId, body) => api.$put(`agencies/${agencyId}/agents/bulk/delete`, body),
  uninstallSelected: (agencyId, body) =>
    api.$put(`agencies/${agencyId}/agents/bulk/uninstall`, body),
  tagSelected: (agencyId, action, body) =>
    api.$put(`agents/tags/agencies/${agencyId}/${action}`, body),
  moveAll: (agencyId, body) => api.$post(`agencies/${agencyId}/agents/moveAll`, body),
  uninstallAll: (agencyId, body) => api.$put(`agencies/${agencyId}/agents/uninstall`, body),
  deleteAll: (agencyId) => api.$delete(`agencies/${agencyId}/agents`),

  vaccinateSelected: (vaccineId, agencyId, body) =>
    api.$put(`vaccines/${vaccineId}/agencies/${agencyId}/agents/apply`, body),
  executeVaccine: (agentId, vaccineId, body) =>
    api.$put(`agents/${agentId}/vaccines/${vaccineId}/apply`, body),
  stopVaccine: (agentId, vaccineId, body) =>
    api.$put(`agents/${agentId}/vaccines/${vaccineId}/stop`, body),

  preparecsv: (agencyId, params) => api.$get(`agencies/${agencyId}/agents/preparecsv`, { params }),
});
